<h2 mat-dialog-title class="d-flex align-items-center">
  <mat-icon *ngIf="data?.titleIcon">{{ data?.titleIcon }}</mat-icon>
  <span *ngIf="data?.titleIcon">&nbsp;</span>
  <span>{{ data?.title }}</span>
</h2>
<mat-dialog-content [class]="data?.contentClass">
  <h3 *ngIf="data?.subtitle">{{ data?.subtitle }}</h3>
  <p *ngIf="data?.description">{{ data?.description }}</p>
  <div class="custom-component-container" *ngIf="data?.component">
    <ng-template
      #customComponent
      [componentLoader]="data?.component?.componentAddress"
      [componentInputs]="data?.component?.componentInputs"
      [componentOutputs]="data?.component?.componentOutputIdsValue"
      [isAsync]="data?.component?.loadAsync"
      (output)="onOutput($event)"
    ></ng-template>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="float-end">
  <button
    *ngFor="let action of data?.actions"
    mat-raised-button
    [color]="action?.isPrimary ? 'primary' : null"
    [disabled]="getActionDisabled(action)"
    (click)="onAction(action)"
  >
    <mat-icon *ngIf="action?.icon">{{ action?.icon }}</mat-icon>
    {{ action?.label | titlecase }}
  </button>
</mat-dialog-actions>
